import React from "react";
import ReviewAnimationRenderer from "./ReviewAnimationRenderer";
import styles from "./ReviewAnimationDataSection.module.scss";
import { Button, ButtonGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";

interface Props {
    videoJob: sage.model.IVideoJob;
}

const ReviewAnimationDataSection: React.FC<Props> = ({ videoJob }) => {
    const dispatch = useDispatch();

    const onUploadNewVideo = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.createAnimation.IStartOver",
        } as sage.actions.createAnimation.IStartOver);
    }, [dispatch]);

    const onDownload = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.createAnimation.ISetTab",
            tab: 3,
        } as sage.actions.createAnimation.ISetTab);
    }, [dispatch]);

    return (
        <div className={styles.outerContainer}>
            <ReviewAnimationRenderer videoJob={videoJob} />
            <ButtonGroup>
                <Button variant="secondary" onClick={onUploadNewVideo}>
                    Start Over
                </Button>
                <Button variant="primary" onClick={onDownload}>
                    Next, Download
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default ReviewAnimationDataSection;
